// // export const API_URL = 'https://api.nahjalsahel.com/';
// export const API_URL = 'https://shayah-api.beetronix.net/';
export const API_URL = 'https://api.shayahco.com/';
// export const API_URL = 'http://127.0.0.1:8000/';


